import { DomainError } from './DomainError';

/**
 * Validation error
 * Thrown when data validation fails
 */
export class ValidationError extends DomainError {
  constructor(
    message: string,
    public readonly field?: string,
    public readonly errors?: Record<string, string[]>,
  ) {
    super(message);
  }

  static fieldRequired(field: string): ValidationError {
    return new ValidationError(`${field} is required`, field);
  }

  static invalidFormat(field: string, format?: string): ValidationError {
    const message = format
      ? `${field} has invalid format: ${format}`
      : `${field} has invalid format`;
    return new ValidationError(message, field);
  }

  static multipleErrors(errors: Record<string, string[]>): ValidationError {
    return new ValidationError('Validation failed', undefined, errors);
  }
}
